var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2253_26926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 18.75C12.179 18.75 11.675 18.246 11.675 17.625C11.675 17.004 12.179 16.5 12.8 16.5C13.421 16.5 13.925 17.004 13.925 17.625C13.925 18.246 13.421 18.75 12.8 18.75ZM11.9562 6H13.6437V14.25H11.9562V6ZM23.9382 11.5868L18.7152 2.649C18.5705 2.4015 18.3072 2.25 18.023 2.25H7.57699C7.29274 2.25 7.02949 2.4015 6.88474 2.649L1.66174 11.5868C1.51249 11.8418 1.51249 12.1582 1.66174 12.4132L6.88474 21.351C7.02949 21.5985 7.29274 21.75 7.57699 21.75H18.023C18.3072 21.75 18.5705 21.5985 18.7152 21.351L23.9382 12.4132C24.0875 12.1582 24.0875 11.8418 23.9382 11.5868Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2253_26926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.799805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.c6a20f566f2df1aa60e45aeec93b312a.svg";
export { ForwardRef as ReactComponent };